<div class="calendar-container">
    <div class="calendar-header">
        <button mat-icon-button (click)="navigate(-1)"
            [matTooltip]="'Previous ' + periodName"><mat-icon>arrow_back_ios</mat-icon></button>
        <div class="calendar-header-buttons">
            <div class="calendar-physician-switcher wide-only" *ngIf="calendarLocations.length">
                <button mat-button [matMenuTriggerFor]="locationFilterMenu" matTooltip="Filter by location">
                    <span>{{ calendarLocationFilterButtonLabel }}</span>
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>
            </div>
            <div class="calendar-physician-switcher wide-only" *ngIf="calendarSplitByPhysician && !showsDoctorColumns">
                <button mat-button [matMenuTriggerFor]="physicianFilterMenu" matTooltip="Filter by physician">
                    <span>{{ calendarPhysicianFilterButtonLabel }}</span>
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>
            </div>
            <mat-menu #locationFilterMenu="matMenu" class="calendar-physician-filter-menu">
                <button mat-menu-item (click)="selectLocationFilterFromMenu(null)">
                    <span>All locations</span>
                </button>
                <button mat-menu-item *ngFor="let location of calendarLocations"
                    (click)="selectLocationFilterFromMenu(location.id)">
                    <span>{{ location.name }}</span>
                </button>
            </mat-menu>
            <div class="calendar-physician-switcher wide-only" *ngIf="calendarView === 'day' && doctorUsersForCalendar.length">
                <button mat-button [matMenuTriggerFor]="dayDoctorsMenu" matTooltip="Doctors to show side by side">
                    <span>{{ dayDoctorsLabel }}</span>
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>
            </div>
            <mat-menu #dayDoctorsMenu="matMenu" class="day-doctors-menu">
                <div class="filter-menu-content" (mousedown)="$event.stopPropagation()">
                    <h3 class="filter-menu-title">Doctors on the day</h3>
                    <div class="filter-options" (click)="$event.stopPropagation()">
                        <div *ngFor="let doctor of doctorUsersForCalendar" class="filter-option">
                            <mat-checkbox [checked]="isDayDoctor(doctor.userId)" (change)="toggleDayDoctor(doctor.userId)"
                                (click)="$event.stopPropagation()">
                                <span>{{ doctorName(doctor) }}</span>
                            </mat-checkbox>
                        </div>
                    </div>
                    <button mat-button (click)="setDayDoctors([])" class="clear-filters-button">All doctors in one column</button>
                </div>
            </mat-menu>
            <mat-menu #physicianFilterMenu="matMenu" class="calendar-physician-filter-menu">
                <button mat-menu-item (click)="selectPhysicianFilterFromMenu(null)">
                    <span>Combined</span>
                </button>
                <button mat-menu-item *ngFor="let u of doctorUsersForCalendar"
                    (click)="selectPhysicianFilterFromMenu(u.userId)">
                    <span>{{ u.title }} {{ u.name }} {{ u.surname }}</span>
                </button>
            </mat-menu>
            <button mat-button (click)="goToToday()" [matTooltip]="'Go to this ' + periodName">Today</button>
            <button mat-button class="period-button" [matMenuTriggerFor]="monthYearMenu" matTooltip="Select month and year">
                {{ daysShown ? rangeLabel : (currentMonth | date: 'MMMM yyyy') }}
                <mat-icon iconPositionEnd>expand_more</mat-icon>
            </button>
            <mat-menu #monthYearMenu="matMenu">
                <div style="padding: 20px;" (mousedown)="$event.stopPropagation()">
                    <mat-form-field appearance="outline" class="full-width" (click)="$event.stopPropagation()"
                        (focus)="$event.stopPropagation()">
                        <mat-label>Month</mat-label>
                        <mat-select [(ngModel)]="selectedMonth" required (click)="$event.stopPropagation()">
                            <mat-option *ngFor="let month of months; let i = index" [value]="i">{{ month }}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="full-width" (click)="$event.stopPropagation()"
                        (focus)="$event.stopPropagation()">
                        <mat-label>Year</mat-label>
                        <input matInput type="number" [(ngModel)]="selectedYear" required
                            (click)="$event.stopPropagation()">
                    </mat-form-field>

                    <button mat-button (click)="onMonthYearChange()">Set</button>
                </div>
            </mat-menu>
            <button mat-icon-button [matMenuTriggerFor]="appointmentTypeFilterMenu"
                matTooltip="Filter: not yet confirmed, appointment types"
                [matBadge]="selectedFiltersCount"
                [matBadgeHidden]="selectedFiltersCount === 0"
                matBadgeColor="warn"
                class="filter-button-with-badge wide-only">
                <mat-icon>filter_list</mat-icon>
            </button>
            <div class="calendar-physician-switcher wide-only">
                <button mat-button [matMenuTriggerFor]="calendarViewMenu" matTooltip="Month, week or day">
                    <span>{{ calendarViewLabel }}</span>
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>
                <mat-menu #calendarViewMenu="matMenu" class="calendar-physician-filter-menu">
                    <button mat-menu-item *ngFor="let view of calendarViews" (click)="setCalendarView(view.value)">
                        <span>{{ view.label }}</span>
                    </button>
                </mat-menu>
            </div>
            <!-- On a phone the filters and views above sit in one menu. -->
            <button mat-icon-button class="phone-only filter-button-with-badge" [matMenuTriggerFor]="calendarMoreMenu"
                aria-label="Calendar options" [matBadge]="selectedFiltersCount"
                [matBadgeHidden]="selectedFiltersCount === 0" matBadgeColor="warn">
                <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #calendarMoreMenu="matMenu" class="calendar-physician-filter-menu">
                <button mat-menu-item *ngIf="calendarLocations.length" [matMenuTriggerFor]="locationFilterMenu">
                    <mat-icon>place</mat-icon>
                    <span>{{ calendarLocationFilterButtonLabel }}</span>
                </button>
                <button mat-menu-item *ngIf="calendarSplitByPhysician && !showsDoctorColumns" [matMenuTriggerFor]="physicianFilterMenu">
                    <mat-icon>person</mat-icon>
                    <span>{{ calendarPhysicianFilterButtonLabel }}</span>
                </button>
                <button mat-menu-item *ngIf="calendarView === 'day' && doctorUsersForCalendar.length" [matMenuTriggerFor]="dayDoctorsMenu">
                    <mat-icon>groups</mat-icon>
                    <span>{{ dayDoctorsLabel }}</span>
                </button>
                <button mat-menu-item [matMenuTriggerFor]="calendarViewMenu">
                    <mat-icon>calendar_view_month</mat-icon>
                    <span>{{ calendarViewLabel }}</span>
                </button>
                <button mat-menu-item [matMenuTriggerFor]="appointmentTypeFilterMenu">
                    <mat-icon>filter_list</mat-icon>
                    <span>Filters{{ selectedFiltersCount ? ' (' + selectedFiltersCount + ')' : '' }}</span>
                </button>
            </mat-menu>
            <mat-menu #appointmentTypeFilterMenu="matMenu" class="appointment-type-filter-menu">
                <div class="filter-menu-content" (mousedown)="$event.stopPropagation()">
                    <div class="filter-option confirm-filter" (click)="$event.stopPropagation()">
                        <mat-checkbox [ngModel]="calendarConfirmFilter.unconfirmedOnly" (ngModelChange)="setUnconfirmedOnly($event)"
                            (click)="$event.stopPropagation()">
                            <span>Not yet confirmed only</span>
                        </mat-checkbox>
                    </div>
                    <h3 class="filter-menu-title">Filter Appointment Types</h3>
                    <div class="filter-options" (click)="$event.stopPropagation()">
                        <div *ngFor="let appointmentType of appointmentTypes" class="filter-option">
                            <mat-checkbox [(ngModel)]="appointmentType.selected" (ngModelChange)="onFilterChange()"
                                (click)="$event.stopPropagation()">
                                <div class="filter-option-content">
                                    <span class="appointment-type-preview"
                                        [ngStyle]="{'background-color': appointmentType.backgroundColor, 'color': appointmentType.textColor, 'border': appointmentType.borderColor ? '2px solid ' + appointmentType.borderColor : '' }">
                                    </span>
                                    <span>{{ appointmentType.type }}</span>
                                </div>
                            </mat-checkbox>
                        </div>
                    </div>
                    <button mat-button (click)="clearFilters()" class="clear-filters-button">Clear Filters</button>
                </div>
            </mat-menu>
        </div>
        <button mat-icon-button (click)="navigate(1)"
            [matTooltip]="'Next ' + periodName"><mat-icon>arrow_forward_ios</mat-icon></button>
    </div>
    <button type="button" class="consent-line" *ngIf="consentLine as line" [class.warn]="line.warn"
        [disabled]="!line.warn" (click)="openConsentWarningDialog()">
        <mat-icon>{{ line.warn ? 'warning' : 'task_alt' }}</mat-icon>
        <span class="consent-line-text">{{ line.text }}</span>
        <mat-icon *ngIf="line.warn" class="consent-line-open">chevron_right</mat-icon>
    </button>
    <div class="calendar-grid" *ngIf="!timeGrid">
        <div class="day-name" *ngFor="let dayName of dayNames">{{ dayName }}</div>
        <ng-container *ngFor="let day of days; let dayIndex = index; trackBy: trackByDay">
            <div class="month-cell"
                [ngClass]="{'today': day.isToday, 'outside': !day.inMonth, 'unavailable': day.inMonth && !day.isAvailable, 'selected': selectedDay && day.date && selectedDay.getTime() === day.date.getTime()}"
                (click)="selectDay(day)">
                <div class="cell-top">
                    <span class="cell-day"><span class="cell-number">{{ day.number }}</span><span class="today-label" *ngIf="day.isToday">Today</span></span>
                    <div class="appointment-counters" *ngIf="day.appointmentCounts.length">
                        <div *ngFor="let count of day.appointmentCounts" class="appointment-count-circle"
                            [matTooltip]="count.type"
                            [ngStyle]="{'background-color': count.backgroundColor,'color': count.textColor, 'border': count.borderColor ? '2px solid ' + count.borderColor : '' }">
                            {{ count.count }}
                        </div>
                    </div>
                </div>

                <div class="bars" *ngIf="day.bars.length">
                    <ng-container *ngFor="let bar of day.bars">
                        <div *ngIf="bar; else freeLane" class="bar" [class.holiday]="bar.event.holiday"
                            [class.continues-before]="bar.continuesBefore" [class.continues-after]="bar.continuesAfter"
                            [style.--bar-color]="bar.event.backgroundColor || null"
                            [matTooltip]="(bar.event.time ? bar.event.time + ' ' : '') + bar.event.title">
                            <span class="bar-title" *ngIf="bar.label"
                                [style.--span]="bar.span"><span class="bar-time" *ngIf="bar.event.time">{{ bar.event.time }}</span>{{ bar.event.title }}</span>
                        </div>
                        <ng-template #freeLane><div class="bar free"></div></ng-template>
                    </ng-container>
                </div>

                <div class="lines" *ngIf="day.preview as preview">
                    <div class="line" *ngFor="let line of preview.lines" [class.inactive]="line.inactive"
                        [matTooltip]="line.tooltip || ''" matTooltipClass="tg-tooltip">
                        <span class="line-dot" [style.background-color]="line.color"></span>
                        <span class="line-time">{{ line.time }}</span>
                        <mat-icon class="line-confirmed" *ngIf="line.confirmed" aria-label="Booking confirmed">event_available</mat-icon>
                        <span class="line-title">{{ line.title }}</span>
                        <span class="practice-name" *ngIf="line.appointment?.practiceName">{{ line.appointment.practiceName }}</span>
                    </div>
                    <div class="more" *ngIf="preview.more">+{{ preview.more }} more</div>
                </div>
            </div>

        </ng-container>

        <!-- Conditionally render the expanded row -->
        <div *ngIf="selectedDay && appointmentsForSelectedDay && startOfWeekIndex !== null" class="appointments-for-day"
            [style.gridRowStart]="appointmentRowStart" [style.gridColumn]="appointmentColumnSpan"
            [@rowAnimation]="'active'">
            <ng-container *ngTemplateOutlet="dayPanel"></ng-container>
        </div>
    </div>

    <!-- Week and day: the selected day's actions, then a Google-style time grid; each booking has its own menu. -->
    <ng-container *ngIf="timeGrid as grid">
        <div class="appointments-for-day time-grid-day-actions" *ngIf="selectedDay">
            <ng-container *ngTemplateOutlet="dayHeader"></ng-container>
        </div>
        <ng-container *ngTemplateOutlet="weekTimeGrid; context: { $implicit: grid }"></ng-container>
    </ng-container>
    <div class="mobile-spacer"></div>

</div>

<ng-template #noResults>
    <p class="no-records-message">No appointments found.</p>
</ng-template>

<!-- Row actions for the day list -->
<ng-template #appointmentActions let-appointment>
    <button mat-icon-button *ngIf="appointment.virtualLink"
        (click)="loadVirtualLink(appointment, $event)"
        matTooltip="Open the virtual meeting link in a new tab">
        <mat-icon>videocam</mat-icon>
    </button>
    <ng-container *ngIf="appointment.showStatusMenu">
        <button mat-icon-button [matMenuTriggerFor]="appointmentMenu"
            (click)="$event.stopPropagation()" matTooltip="Set Appointment Status">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #appointmentMenu="matMenu">
            <ng-container *ngTemplateOutlet="statusMenuItems; context: { $implicit: appointment }"></ng-container>
        </mat-menu>
    </ng-container>
    <ng-container *ngIf="appointment.showDoctorCompletionMenu">
        <button mat-icon-button [matMenuTriggerFor]="doctorMenu"
            (click)="$event.stopPropagation()" matTooltip="Doctor Actions">
            <mat-icon>medical_services</mat-icon>
        </button>
        <mat-menu #doctorMenu="matMenu">
            <button mat-menu-item (click)="markNoteAsSaved(appointment, $event)"
                matTooltip="The visit is done and its note is saved">
                <mat-icon>task_alt</mat-icon>
                <span>Mark as Completed</span>
            </button>
        </mat-menu>
    </ng-container>
    <button mat-icon-button (click)="rescheduleAppointment(appointment, $event)" *ngIf="!appointment.practiceName"
        [matTooltip]="appointment.reason ? 'Edit Event' : 'Reschedule Appointment'">
        <mat-icon>edit_calendar</mat-icon>
    </button>
    <button mat-icon-button matTooltip="View Patient" *ngIf="!appointment.reason">
        <mat-icon>visibility</mat-icon>
    </button>
</ng-template>



<!-- Status options of a booking, in the day list row's menu and the time grid's. -->
<ng-template #statusMenuItems let-appointment>
    <button mat-menu-item *ngIf="appointment.showConfirmOption"
        (click)="updateAppointmentStatus(appointment, 'confirmed', $event)"
        matTooltip="The patient has confirmed this booking">
        <mat-icon class="confirmed-icon">event_available</mat-icon>
        <span>Confirmed</span>
    </button>
    <button mat-menu-item *ngIf="appointment.showNotConfirmOption"
        (click)="updateAppointmentStatus(appointment, 'not_confirmed', $event)"
        [matTooltip]="appointment.confirmedTooltip">
        <mat-icon>event_busy</mat-icon>
        <span>Not Confirmed</span>
    </button>
    <mat-divider *ngIf="appointment.showConfirmOption || appointment.showNotConfirmOption"></mat-divider>
    <button mat-menu-item *ngIf="appointment.showArrivedOption"
        (click)="updateAppointmentStatus(appointment, 'arrived', $event)"
        matTooltip="Mark patient as arrived">
        <mat-icon>check_circle</mat-icon>
        <span>Arrived</span>
    </button>
    <button mat-menu-item *ngIf="appointment.showNotArrivedOption"
        (click)="updateAppointmentStatus(appointment, 'not_arrived', $event)"
        matTooltip="Mark patient as not arrived">
        <mat-icon>schedule</mat-icon>
        <span>Not Arrived</span>
    </button>
    <mat-divider
        *ngIf="appointment.showArrivedOption || appointment.showNotArrivedOption"></mat-divider>
    <button mat-menu-item *ngIf="appointment.showCancelledOption"
        (click)="updateAppointmentStatus(appointment, 'cancelled', $event)"
        matTooltip="Cancel this appointment">
        <mat-icon>cancel</mat-icon>
        <span>Cancelled</span>
    </button>
    <button mat-menu-item *ngIf="appointment.showNotCancelledOption"
        (click)="updateAppointmentStatus(appointment, 'not_cancelled', $event)"
        matTooltip="Uncancel this appointment">
        <mat-icon>restore</mat-icon>
        <span>Not Cancelled</span>
    </button>
    <mat-divider
        *ngIf="appointment.showCancelledOption || appointment.showNotCancelledOption"></mat-divider>
    <button mat-menu-item *ngIf="appointment.showDidNotAttendOption"
        (click)="updateAppointmentStatus(appointment, 'did_not_attend', $event)"
        matTooltip="Mark patient as did not attend">
        <mat-icon>person_off</mat-icon>
        <span>Did Not Attend</span>
    </button>
    <button mat-menu-item *ngIf="appointment.showDidAttendOption"
        (click)="updateAppointmentStatus(appointment, 'did_attend', $event)"
        matTooltip="Mark patient as did attend">
        <mat-icon>person</mat-icon>
        <span>Did Attend</span>
    </button>
    <ng-container *ngIf="appointment.showCompletedOption">
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="updateAppointmentStatus(appointment, 'completed', $event)"
            matTooltip="The visit is done and its recording loaded">
            <mat-icon>task_alt</mat-icon>
            <span>Completed</span>
        </button>
    </ng-container>
</ng-template>

<!-- A time grid booking's menu: what its day list row offers. -->
<mat-menu #timeGridEventMenu="matMenu" class="tg-event-menu-panel">
    <ng-template matMenuContent let-appointment="appointment">
        <!-- The booking's details first, as the month's open day shows them; on a phone this is where they are read. -->
        <div class="tg-menu-details" (click)="$event.stopPropagation()" *ngIf="bookingDetails(appointment) as details">
            <div class="tg-menu-title">{{ appointment.Patient ? appointment.Patient.surname + ', ' + appointment.Patient.name : appointment.reason }}</div>
            <div class="tg-menu-detail" *ngFor="let detail of details">
                <span class="tg-menu-label">{{ detail.label }}</span><span>{{ detail.value }}</span>
            </div>
        </div>
        <mat-divider></mat-divider>
        <button mat-menu-item *ngIf="appointment.virtualLink" (click)="loadVirtualLink(appointment, $event)">
            <mat-icon>videocam</mat-icon>
            <span>Open meeting link</span>
        </button>
        <ng-container *ngIf="appointment.showStatusMenu">
            <ng-container *ngTemplateOutlet="statusMenuItems; context: { $implicit: appointment }"></ng-container>
            <mat-divider></mat-divider>
        </ng-container>
        <ng-container *ngIf="appointment.showDoctorCompletionMenu">
            <button mat-menu-item (click)="markNoteAsSaved(appointment, $event)">
                <mat-icon>task_alt</mat-icon>
                <span>Mark as Completed</span>
            </button>
            <mat-divider></mat-divider>
        </ng-container>
        <button mat-menu-item (click)="rescheduleAppointment(appointment, $event)">
            <mat-icon>edit_calendar</mat-icon>
            <span>{{ appointment.reason ? 'Edit event' : 'Reschedule' }}</span>
        </button>
        <button mat-menu-item *ngIf="appointment.Patient" (click)="openTimeGridEvent(appointment, $event)">
            <mat-icon>visibility</mat-icon>
            <span>View patient</span>
        </button>
    </ng-template>
</mat-menu>

<!-- The open day's title and actions: above the month's day list, and above the week and day grids. -->
<ng-template #dayHeader>
        <div class="row-header">
            <h3>Appointments for {{ selectedDay | date: 'fullDate' }}:<span class="today-chip" *ngIf="(selectedDay | date: 'yyyy-MM-dd') === (now | date: 'yyyy-MM-dd')">Today</span></h3>
            <div class="actions">
                <button mat-icon-button color="primary" (click)="exportDayAppointments()"
                    matTooltip="Export day's appointments" [disabled]="!hasAppointmentsToExport">
                    <mat-icon>download</mat-icon>
                </button>
                <!-- §3b — the theatre list is a day export. Offered ONLY when the day holds
                     at least one isProcedure appointment; a day of consultations has no
                     theatre list, so the action is absent rather than disabled. -->
                <button mat-icon-button color="primary" class="export-theatre-list"
                    *ngIf="hasProcedureAppointmentsToExport" (click)="exportDayTheatreList()"
                    matTooltip="Export theatre list">
                    <mat-icon>medical_services</mat-icon>
                </button>
                <button mat-icon-button color="primary" (click)="openOpenSlots()"
                    *ngIf="isSelectedDayFuture" matTooltip="Open time slots">
                    <mat-icon>event_available</mat-icon>
                </button>
                <button mat-icon-button color="primary" (click)="addEvent()" *ngIf="isSelectedDayFuture"
                    matTooltip="Add Event">
                    <mat-icon>event</mat-icon>
                </button>
                <button mat-icon-button color="primary" (click)="openScheduleDialog()"
                    *ngIf="isSelectedDayFuture" matTooltip="Schedule Patient">
                    <mat-icon>person_add_alt</mat-icon>
                </button>
            </div>
        </div>
</ng-template>

<!-- The open day: summary, actions and the compact list. -->
<ng-template #dayPanel>
        <ng-container *ngTemplateOutlet="dayHeader"></ng-container>
        <div class="compact-day" *ngIf="appointmentsForSelectedDay?.length">
            <div class="compact-summary" *ngIf="daySummaryText || drift">
                <span>{{ daySummaryText }}</span>
                <span class="drift" *ngIf="drift" [ngClass]="drift.level">
                    <mat-icon>{{ drift.minutes > 30 ? 'schedule' : 'check_circle' }}</mat-icon>{{ drift.text }}
                </span>
            </div>
            <ng-container *ngFor="let appointment of appointmentsForSelectedDay; trackBy: trackByAppointment; let i = index">
            <div class="now-line" *ngIf="i === nowLine?.index && nowLine?.within === null" role="separator" [attr.aria-label]="'Now ' + (now | date:'HH:mm')"><span class="now-time">{{ now | date:'HH:mm' }}</span></div>
            <div class="compact-row"
                [class.inactive]="appointment.dayStatus?.key === 'cancelled' || appointment.dayStatus?.key === 'did-not-attend'"
                [class.clickable]="!!appointment.Patient"
                [class.event]="!appointment.Patient && !!appointment.reason"
                (click)="openBooking(appointment)"
                [appPatientValidationStatus]="appointment.Patient ?? {}" #valStatus="appPatientValidationStatus"
                [appPatientActive]="appointment.Patient?.id">
                <div class="now-line within" *ngIf="i === nowLine?.index && nowLine?.within !== null"
                    [style.top.%]="(nowLine?.within ?? 0) * 100" role="separator" [attr.aria-label]="'Now ' + (now | date:'HH:mm')">
                    <span class="now-time">{{ now | date:'HH:mm' }}</span></div>
                <span class="status-dot appointment-status" *ngIf="!appointment.reason"
                    [ngClass]="appointment.dayStatus?.key" [matTooltip]="appointment.tooltip" matTooltipClass="tg-tooltip"></span>
                <span class="type-bar" [matTooltip]="appointment.tooltip" matTooltipClass="tg-tooltip"
                    [ngStyle]="{'background-color': appointment.typeDetails?.backgroundColor, 'border-color': appointment.typeDetails?.borderColor || appointment.typeDetails?.backgroundColor}"></span>
                <span class="time" [matTooltip]="appointment.tooltip" matTooltipClass="tg-tooltip">{{ timeLabel(appointment) }}<mat-icon
                    class="confirmed-tick" *ngIf="appointment.confirmedAt && !appointment.reason"
                    aria-label="Booking confirmed">event_available</mat-icon></span>
                <!-- Each part of the row has the same full hover, as the week and day views; the warning icons keep their own. -->
                <span class="who" [matTooltip]="appointment.tooltip" matTooltipClass="tg-tooltip">
                    <ng-container *ngIf="appointment.Patient; else eventLabel">
                        <span class="name">{{ appointment.Patient.surname }}, {{ appointment.Patient.name }}</span>
                        <span class="number" *ngIf="appointment.Patient.patientNumber">({{ appointment.Patient.patientNumber }})</span>
                        <span class="diagnosis" *ngIf="appointment.compactDiagnosis">{{ appointment.compactDiagnosis }}</span>
                        <span class="practice-name" *ngIf="appointment.practiceName">{{ appointment.practiceName }}</span>
                    </ng-container>
                    <ng-template #eventLabel><span class="name">{{ appointment.reason }}</span></ng-template>
                </span>
                <span class="flags">
                    <app-patient-validation-messages *ngIf="appointment.Patient" [valStatus]="valStatus"
                        [iconsOnly]="true"></app-patient-validation-messages>
                </span>
                <span class="what" [matTooltip]="appointment.tooltip" matTooltipClass="tg-tooltip">{{ appointment.appointmentType }}{{ appointment.virtualLink ? ' (Virtual)' : '' }}{{ appointment.compactDetail ? ' · ' + appointment.compactDetail : '' }}</span>
                <span class="state" [ngClass]="appointment.dayStatus?.key" *ngIf="appointment.dayStatus?.label && !appointment.reason"
                    [matTooltip]="appointment.tooltip" matTooltipClass="tg-tooltip">{{ appointment.dayStatus.label }}</span>
                <span class="state event" *ngIf="appointment.reason">Event</span>
                <div class="actions">
                    <ng-container *ngTemplateOutlet="appointmentActions; context: { $implicit: appointment }"></ng-container>
                </div>
            </div>
            </ng-container>
            <div class="now-line" *ngIf="nowLine?.index === appointmentsForSelectedDay?.length" role="separator" [attr.aria-label]="'Now ' + (now | date:'HH:mm')"><span class="now-time">{{ now | date:'HH:mm' }}</span></div>
        </div>
</ng-template>
<!-- Week and day views, laid out like Google Calendar: day (or doctor) heads, an all-day strip, then
     hours down the side with each booking placed by its time and as tall as it lasts. Free slots show
     on hover and book that time. -->
<ng-template #weekTimeGrid let-grid>
    <div class="time-grid" [style.--tg-days]="grid.columns.length" [class.week-columns]="calendarView === 'week'"
        [class.doctor-columns]="calendarView === 'day' && grid.columns.length > 1">
        <div class="tg-row tg-head">
            <div class="tg-gutter"></div>
            <div class="tg-day-head" *ngFor="let col of grid.columns; trackBy: trackByColumn"
                [class.today]="col.day.isToday" [class.unavailable]="!col.day.isAvailable"
                [class.selected]="selectedDay && selectedDay.getTime() === col.day.date.getTime()"
                (click)="selectDay(col.day)">
                <span class="tg-doctor-name" *ngIf="col.label; else dayHead">{{ col.label }}</span>
                <ng-template #dayHead>
                    <span class="tg-day-name">{{ col.day.date | date: 'EEE' }}</span>
                    <span class="tg-day-number">{{ col.day.number }}</span>
                </ng-template>
            </div>
        </div>

        <div class="tg-row tg-allday" *ngIf="grid.hasBars">
            <div class="tg-gutter"></div>
            <ng-container *ngFor="let col of grid.columns; let first = first; trackBy: trackByColumn">
            <div class="month-cell tg-allday-cell" *ngIf="first || !col.label"
                [style.grid-column]="col.label ? '2 / -1' : null"
                (click)="selectDay(col.day)">
                <div class="bars">
                    <ng-container *ngFor="let bar of col.day.bars">
                        <div *ngIf="bar; else freeLane" class="bar" [class.holiday]="bar.event.holiday"
                            [class.continues-before]="bar.continuesBefore" [class.continues-after]="bar.continuesAfter"
                            [style.--bar-color]="bar.event.backgroundColor || null"
                            [matTooltip]="(bar.event.time ? bar.event.time + ' ' : '') + bar.event.title">
                            <span class="bar-title" *ngIf="bar.label"
                                [style.--span]="bar.span"><span class="bar-time" *ngIf="bar.event.time">{{ bar.event.time }}</span>{{ bar.event.title }}</span>
                        </div>
                        <ng-template #freeLane><div class="bar free"></div></ng-template>
                    </ng-container>
                </div>
            </div>
            </ng-container>
        </div>

        <div class="tg-row tg-body" [style.height.px]="grid.hours.length * timeGridHourHeight"
            [style.--hour-height.px]="timeGridHourHeight">
            <div class="tg-gutter tg-hours">
                <span class="tg-hour" *ngFor="let hour of grid.hours; let i = index" [style.top.px]="i * timeGridHourHeight">{{ hour }}</span>
                <span class="tg-now-time" *ngIf="grid.nowTop !== null" [style.top.%]="grid.nowTop">{{ grid.nowLabel }}</span>
            </div>
            <div class="tg-column" *ngFor="let col of grid.columns; trackBy: trackByColumn"
                [class.unavailable]="!col.day.isAvailable" [class.today]="col.day.isToday && grid.columns.length > 1 && !col.label"
                (click)="selectDay(col.day)"
                (dragover)="onTimeGridDragOver(col, $event)" (drop)="onTimeGridDrop(col, $event)">
                <div class="tg-drop-hint" *ngIf="dropHint && dropHint.columnKey === trackByColumn(0, col)"
                    [style.top.%]="dropHint.top" [style.height.%]="dropHint.height">{{ dropHint.time }}</div>
                <!-- An empty slot fills the column; one already holding bookings (with room left) sits in the
                     strip the bookings leave on the right. -->
                <button type="button" class="tg-slot" *ngFor="let slot of col.slots; trackBy: trackBySlot"
                    [class.places-left]="slot.taken > 0"
                    [style.top.%]="slot.top" [style.height.%]="slot.height"
                    [attr.aria-label]="'Book ' + slot.time + (col.label ? ' with ' + col.label : '')"
                    [matTooltip]="slot.taken > 0 ? (slot.remaining === null ? 'Book another patient at ' + slot.time : slot.remaining + (slot.remaining === 1 ? ' place' : ' places') + ' left at ' + slot.time) : ''"
                    (click)="bookSlot(col, slot, $event)"><mat-icon>add</mat-icon><ng-container *ngIf="slot.taken === 0; else placesLeft">{{ slot.time }}</ng-container><ng-template #placesLeft>+{{ slot.remaining ?? '' }}</ng-template></button>
                <div class="tg-lane" [class.shared]="grid.sharedSlots">
                <div class="tg-event" *ngFor="let event of col.events; trackBy: trackByTimeGridEvent"
                    [class.inactive]="event.inactive" [class.short]="event.short"
                    [style.top.%]="event.top" [style.height.%]="event.height"
                    [style.left.%]="event.left" [style.width.%]="event.width"
                    [style.--event-color]="event.color"
                    [class.draggable]="canDragBooking(event.appointment)"
                    [class.dragging]="draggingBooking?.id === event.appointment.id"
                    [attr.draggable]="canDragBooking(event.appointment)"
                    (dragstart)="onTimeGridDragStart(event.appointment, $event)" (dragend)="onTimeGridDragEnd()"
                    [matTooltip]="event.tooltip" matTooltipClass="tg-tooltip"
                    (click)="openTimeGridEvent(event.appointment, $event, eventMenu)">
                    <!-- The day view has room for the file number and the reason for visit (or else the
                         diagnosis); a tall booking adds the diagnosis. The week shows name and time. -->
                    <span class="tg-event-title"><mat-icon class="tg-confirmed" *ngIf="event.appointment?.confirmedAt"
                        aria-label="Booking confirmed">event_available</mat-icon>{{ event.title }}<span class="tg-event-file"
                        *ngIf="calendarView === 'day' && event.fileNumber"> · {{ event.fileNumber }}</span></span>
                    <span class="tg-event-time">{{ event.time }}<ng-container *ngIf="calendarView === 'day' && event.subtitle"> · {{ event.subtitle }}</ng-container></span>
                    <span class="practice-name" *ngIf="event.appointment?.practiceName">{{ event.appointment.practiceName }}</span>
                    <span class="tg-event-extra" *ngIf="calendarView === 'day' && event.tall && event.diagnosis">{{ event.diagnosis }}</span>
                    <button mat-icon-button class="tg-event-menu" #eventMenu="matMenuTrigger" [hidden]="!!event.appointment?.practiceName" [matMenuTriggerFor]="timeGridEventMenu"
                        [matMenuTriggerData]="{ appointment: event.appointment }" aria-label="Appointment options"
                        (click)="$event.stopPropagation()"><mat-icon>more_vert</mat-icon></button>
                </div>
                </div>
                <div class="tg-now" *ngIf="col.nowTop !== null" [style.top.%]="col.nowTop" role="separator" [attr.aria-label]="'Now ' + grid.nowLabel"></div>
            </div>
        </div>
    </div>
</ng-template>
